import { createSlice } from '@reduxjs/toolkit';
// TODO fix no cycle error
// eslint-disable-next-line import/no-cycle
import { RootState } from '../store';

const initialState = {
  isLoggedIn: false,
};

export const navBarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    logIn: (state) => {
      state.isLoggedIn = true;
    },
    logOut: (state) => {
      state.isLoggedIn = false;
    },
  },
});

export const { setIsLoggedIn, logIn, logOut } = navBarSlice.actions;
export const navBarSelector = (state: RootState) => state.navBar;

export default navBarSlice.reducer;
